import type { FetchResponse } from '@sydle/ui-api';
import { portalCustomAPI } from '.';

export interface RecoverPasswordInput {
  username: string;
  appIdentifier?: string;
  app?: string;
  useCustomRecover?: boolean;
}

export interface RecoverPasswordOutput {
  email: string;
}

export async function recoverPassword(input: RecoverPasswordInput): Promise<FetchResponse<RecoverPasswordOutput>> {
  return await portalCustomAPI.fetch<RecoverPasswordInput, RecoverPasswordOutput>('recoverPassword', input);
}
